export default __webpack_public_path__ + "static/media/3.91d3488a.png";